import DayDetailsCellRenderer from "./DayDetailsCellRenderer";

export default class OvertimeDayDetailsCellRenderer extends DayDetailsCellRenderer {
    constructor(cssBaseClass, cssTopBorderClass, cssAdditionalClass) {
        super(cssBaseClass, cssTopBorderClass);
        this.cssAdditionalClass = cssAdditionalClass;
    }

    getCellClassName(cell) {
        let baseClass = DayDetailsCellRenderer.prototype.getCellClassName.call(this, cell)
        return baseClass + " " + this.cssAdditionalClass;
    }

    addTooltip(cell) {
        cell.getRow().getTable().getTooltipController().addDayTooltip(cell.getCellEl(),
            cell.getRow().getParentRow().getHeaderCell().getValue().id,
            cell.getRow().getTable().getDatesRow().getCell(cell.getColIdx()).getValue().date,
            undefined,
            {showOvertimeWhenZero: true, time: cell.getValue(), showTime: false, overtimeText: cell.getRow().getHeaderCell().getValue()},
            cell.getRow().getParentRow().getCell(cell.getColIdx()).getValue());
    }
}


// WEBPACK FOOTER //
// ./web/js/locktable/renderers/OvertimeDayDetailsCellRenderer.js